// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__35cmH","noInteraction":"EventWrapper_noInteraction__1-ecA","pointerPassthrough":"EventWrapper_pointerPassthrough__3I7P9"};